<mat-sidenav-container class="notifications-sidebar" >
    <mat-sidenav-content>
        <app-announcements></app-announcements>
        <app-top-navigation
            (notificationToggle)="notificationToggle.toggle()"
            (viewFav)="gotoFavoritesSection()"
            #topNavigation
        >
        </app-top-navigation>
        <div class="header-bg">
            <div class="headline">
                <img src="./assets/images/dxc-bg.png">
                <div class="container">
                    <div class="row">
                        <div class="col text-center">
                            <h1 class="greeting">
                                <span *ngIf="greeting$ | async as greeting">{{greetingMessage$ | async}}{{greeting}}</span>
                            </h1>
                            <app-search></app-search>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nav-button">
                <div class="container button-wrapper">
                    <button
                        mat-raised-button
                        id="DXCHubButton"
                        class="large-btn"
                        (click)="showDxcHubContent()"
                        [ngClass]="isShow === consts.VALUE_DXCHUB ? 'large-btn-active' : ''"
                    >
                        {{consts.LABEL_BUTTON_DXCHUB}}
                    </button>
                    <button
                        mat-raised-button
                        id="MyHubButton"
                        class="large-btn"
                        (click)="showMyHubContent();"
                        [ngClass]="isShow === consts.VALUE_MYHUB ? 'large-btn-active' : ''"
                    >
                        {{consts.LABEL_BUTTON_MYHUB}}
                    </button>
                </div>
            </div>
        </div>
        <div class="main-content dxchub" [style.display]="isShow === consts.VALUE_DXCHUB ? 'block': 'none'">
            <div class="container">
                <div class="row">
                    <div class="col-md-7">
                        <app-latest-news></app-latest-news>
                    </div>
                    <div class="col-md-5">
                        <app-quick-links></app-quick-links>
                    </div>
                </div>
                <div class="row">
                    <app-global-functions></app-global-functions>
                </div>
                <div class="row">
                    <app-trending></app-trending>
                </div>
                <div class="row" id="tools">
                    <app-tools-and-resources></app-tools-and-resources>
                </div>
            </div>
        </div>
        <!-- Remove Qualtrics Feedback function from DXC Hub & My Hub - Story: https://dev.azure.com/DXCIT/DXC%20IT%20Backlog/_workitems/edit/114800 -->
        <!-- <div class="feedback-section">
            <app-feedback></app-feedback>
        </div> -->
        <div class="main-content myhub" [style.display]="isShow === consts.VALUE_MYHUB ? 'block': 'none'">
            <div class="container">
                <div class="row" id="HubWorkProfile" #WorkProfile>
                    <app-work-profile></app-work-profile>
                </div>
                <div class="row">
                    <app-recent-shared-files></app-recent-shared-files>
                </div>
                <div class="row" #HubFavorites>
                    <app-favorite-widget></app-favorite-widget>
                </div>
                <div class="row">
                    <app-calendar-events></app-calendar-events>
                </div>
            </div>
        </div>
        <div class="footer-section">
            <div class="container">
                <app-footer [logo]="consts.DXC_LOGO.BLACK"></app-footer>
            </div>
        </div>
    </mat-sidenav-content>
    <mat-sidenav #notificationToggle mode="over" opened="false" position="end" fixedInViewport (closedStart)="topNavigation.refreshNoifList()">
        <h3 class="notify-title">
            {{consts.TITLE_NOTIFICATIONS}}
            <mat-icon
                class="dialog-close-button"
                (click)="notificationToggle.close()"
                svgIcon="hub_close"
            >
            </mat-icon
        >
        </h3>
        <app-notifications></app-notifications>
    </mat-sidenav>
</mat-sidenav-container>
